import { takeLatest } from 'redux-saga/effects';
import {
    GetBankSaga,
    GetDesignationSaga,
    AddDesignationSaga,
    UpdateDesignationSaga,
    DeleteDesignationSaga,
    GetJobSaga,
    GetRelationshipSaga,
    GetStudyLevelSaga,
    AddStudyLevelSaga,
    UpdateStudyLevelSaga,
    DeleteStudyLevelSaga,
    GetStudyProgramSaga,
    AddStudyProgramSaga,
    UpdateStudyProgramSaga,
    DeleteStudyProgramSaga,
    GetEmploymentTypeSaga,
    AddEmploymentTypeSaga,
    UpdateEmploymentTypeSaga,
    DeleteEmploymentTypeSaga,
    GetPaygradeSaga,
    GetCostCenterSaga,
    AddCostCenterSaga,
    UpdateCostCenterSaga,
    DeleteCostCenterSaga,
    GetHolidayCalendarCitySaga,
    AddBankSaga,
    UpdateBankSaga,
    DeleteBankSaga,
    GetLeavingReasonSaga,
    AddLeavingReasonSaga,
    UpdateLeavingReasonSaga,
    DeleteLeavingReasonSaga,
    UpdateRelationshipSaga,
    DeleteRelationshipSaga,
    AddRelationshipSaga,
    AddJobSaga,
    UpdateJobSaga,
    DeleteJobSaga,
    GetBusinessUnitSaga,
    AddBusinessUnitSaga,
    UpdateBusinessUnitSaga,
    DeleteBusinessUnitSaga,
    GetSubBusinessUnitSaga,
    AddSubBusinessUnitSaga,
    UpdateSubBusinessUnitSaga,
    DeleteSubBusinessUnitSaga,
    GetCasteSaga,
    AddCasteSaga,
    UpdateCasteSaga,
    DeleteCasteSaga,
    AddPaygradeSaga,
    UpdatePaygradeSaga,
    DeletePaygradeSaga,
    GetWorkLocationSaga,
    AddWorkLocationSaga,
    UpdateWorkLocationSaga,
    DeleteWorkLocationSaga,
    GetCityListSaga,
    GetProofTypeSaga,
    AddProofTypeSaga,
    UpdateProofTypeSaga,
    DeleteProofTypeSaga,
    GetNotificationSaga,
    AddNotificationSaga,
    UpdateNotificationSaga,
    GetDocumentationsSaga,
    AddDocumentationsSaga,
    UpdateDocumentationsSaga,
    DeleteDocumentationsSaga,
    GetUsersSaga,
    GetConfigureStatusSaga,
    UpdateConfigureStatusSaga,
    GetCountrySaga,
    GetWeekDaysSaga,
    GetAllNotificationSaga,
    GetSubscriptionSaga,
    UpdateSubscriptionSaga,
    GetLetterHeadSaga,
    UpdateLetterHeadSaga,
    GetReportScheduleSaga,
    UpdateReportScheduleSaga,
    DeleteReportScheduleSaga,
    GetWorkSpaceDojSaga,
    GetCompanyLogoSaga,
    UpdateCompanyLogoSaga,
    LoadFaceApiModelsSaga,
    GetAITokenConfig,
    AddAITokenConfig,
    UpdateAITokenConfig,
    DeleteAITokenConfig,
    TestModel,
    GetAccessWorkLocationSaga,
    GetCompanyConfigSaga,
    UpdateCompanyConfigSaga,
    GetContractorSaga,
    AddContractorSaga,
    UpdateContractorSaga,
    DeleteContractorSaga,
    GetWhatsappConfigSaga,
    UpsertWhatsappConfigSaga,
    TestWhatsappConfigSaga
} from './AncillarySaga';
import * as ActionTypes from './ActionTypes';

export default function* AncillaryWatcher() {
    yield takeLatest(ActionTypes.RELATIONSHIP_GET_REQUEST, GetRelationshipSaga);
    yield takeLatest(ActionTypes.RELATIONSHIP_ADD_REQUEST, AddRelationshipSaga);
    yield takeLatest(ActionTypes.RELATIONSHIP_UPDATE_REQUEST, UpdateRelationshipSaga);
    yield takeLatest(ActionTypes.RELATIONSHIP_DELETE_REQUEST, DeleteRelationshipSaga);
    yield takeLatest(ActionTypes.GET_BANK_REQUEST, GetBankSaga);
    yield takeLatest(ActionTypes.ADD_BANK_REQUEST, AddBankSaga);
    yield takeLatest(ActionTypes.UPDATE_BANK_REQUEST, UpdateBankSaga);
    yield takeLatest(ActionTypes.DELETE_BANK_REQUEST, DeleteBankSaga);
    yield takeLatest(ActionTypes.STUDYLEVEL_GET_REQUEST, GetStudyLevelSaga);
    yield takeLatest(ActionTypes.STUDYLEVEL_ADD_REQUEST, AddStudyLevelSaga);
    yield takeLatest(ActionTypes.STUDYLEVEL_UPDATE_REQUEST, UpdateStudyLevelSaga);
    yield takeLatest(ActionTypes.STUDYLEVEL_DELETE_REQUEST, DeleteStudyLevelSaga);
    yield takeLatest(ActionTypes.STUDYPROGRAM_GET_REQUEST, GetStudyProgramSaga);
    yield takeLatest(ActionTypes.STUDYPROGRAM_ADD_REQUEST, AddStudyProgramSaga);
    yield takeLatest(ActionTypes.STUDYPROGRAM_UPDATE_REQUEST, UpdateStudyProgramSaga);
    yield takeLatest(ActionTypes.STUDYPROGRAM_DELETE_REQUEST, DeleteStudyProgramSaga);
    yield takeLatest(ActionTypes.DESIGNATION_GET_REQUEST, GetDesignationSaga);
    yield takeLatest(ActionTypes.DESIGNATION_ADD_REQUEST, AddDesignationSaga);
    yield takeLatest(ActionTypes.DESIGNATION_UPDATE_REQUEST, UpdateDesignationSaga);
    yield takeLatest(ActionTypes.DESIGNATION_DELETE_REQUEST, DeleteDesignationSaga);
    yield takeLatest(ActionTypes.JOB_GET_REQUEST, GetJobSaga);
    yield takeLatest(ActionTypes.JOB_ADD_REQUEST, AddJobSaga);
    yield takeLatest(ActionTypes.JOB_UPDATE_REQUEST, UpdateJobSaga);
    yield takeLatest(ActionTypes.JOB_DELETE_REQUEST, DeleteJobSaga);
    yield takeLatest(ActionTypes.EMPLOYMENT_TYPE_GET_REQUEST, GetEmploymentTypeSaga);
    yield takeLatest(ActionTypes.EMPLOYMENT_TYPE_ADD_REQUEST, AddEmploymentTypeSaga);
    yield takeLatest(ActionTypes.EMPLOYMENT_TYPE_UPDATE_REQUEST, UpdateEmploymentTypeSaga);
    yield takeLatest(ActionTypes.EMPLOYMENT_TYPE_DELETE_REQUEST, DeleteEmploymentTypeSaga);
    yield takeLatest(ActionTypes.PAYGRADE_GET_REQUEST, GetPaygradeSaga);
    yield takeLatest(ActionTypes.PAYGRADE_ADD_REQUEST, AddPaygradeSaga);
    yield takeLatest(ActionTypes.PAYGRADE_UPDATE_REQUEST, UpdatePaygradeSaga);
    yield takeLatest(ActionTypes.PAYGRADE_DELETE_REQUEST, DeletePaygradeSaga);
    yield takeLatest(ActionTypes.COST_CENTER_GET_REQUEST, GetCostCenterSaga);
    yield takeLatest(ActionTypes.COST_CENTER_ADD_REQUEST, AddCostCenterSaga);
    yield takeLatest(ActionTypes.COST_CENTER_UPDATE_REQUEST, UpdateCostCenterSaga);
    yield takeLatest(ActionTypes.COST_CENTER_DELETE_REQUEST, DeleteCostCenterSaga);
    yield takeLatest(ActionTypes.CITY_LIST_GET_REQUEST, GetCityListSaga);
    yield takeLatest(ActionTypes.HOLIDAY_CALENDAR_CITY_GET_REQUEST, GetHolidayCalendarCitySaga);
    yield takeLatest(ActionTypes.LEAVING_REASON_GET_REQUEST, GetLeavingReasonSaga);
    yield takeLatest(ActionTypes.LEAVING_REASON_ADD_REQUEST, AddLeavingReasonSaga);
    yield takeLatest(ActionTypes.LEAVING_REASON_UPDATE_REQUEST, UpdateLeavingReasonSaga);
    yield takeLatest(ActionTypes.LEAVING_REASON_DELETE_REQUEST, DeleteLeavingReasonSaga);
    yield takeLatest(ActionTypes.BUSINESSUNIT_GET_REQUEST, GetBusinessUnitSaga);
    yield takeLatest(ActionTypes.BUSINESSUNIT_ADD_REQUEST, AddBusinessUnitSaga);
    yield takeLatest(ActionTypes.BUSINESSUNIT_UPDATE_REQUEST, UpdateBusinessUnitSaga);
    yield takeLatest(ActionTypes.BUSINESSUNIT_DELETE_REQUEST, DeleteBusinessUnitSaga);
    yield takeLatest(ActionTypes.SUB_BUSINESSUNIT_GET_REQUEST, GetSubBusinessUnitSaga);
    yield takeLatest(ActionTypes.SUB_BUSINESSUNIT_ADD_REQUEST, AddSubBusinessUnitSaga);
    yield takeLatest(ActionTypes.SUB_BUSINESSUNIT_UPDATE_REQUEST, UpdateSubBusinessUnitSaga);
    yield takeLatest(ActionTypes.SUB_BUSINESSUNIT_DELETE_REQUEST, DeleteSubBusinessUnitSaga);
    yield takeLatest(ActionTypes.CASTE_GET_REQUEST, GetCasteSaga);
    yield takeLatest(ActionTypes.CASTE_ADD_REQUEST, AddCasteSaga);
    yield takeLatest(ActionTypes.CASTE_UPDATE_REQUEST, UpdateCasteSaga);
    yield takeLatest(ActionTypes.CASTE_DELETE_REQUEST, DeleteCasteSaga);
    yield takeLatest(ActionTypes.WORK_LOCATION_GET_REQUEST, GetWorkLocationSaga);
    yield takeLatest(ActionTypes.WORK_LOCATION_ADD_REQUEST, AddWorkLocationSaga);
    yield takeLatest(ActionTypes.WORK_LOCATION_UPDATE_REQUEST, UpdateWorkLocationSaga);
    yield takeLatest(ActionTypes.WORK_LOCATION_DELETE_REQUEST, DeleteWorkLocationSaga);
    yield takeLatest(ActionTypes.USER_WORK_LOCATION_GET_REQUEST, GetAccessWorkLocationSaga);
    yield takeLatest(ActionTypes.PROOF_TYPE_GET_REQUEST, GetProofTypeSaga);
    yield takeLatest(ActionTypes.PROOF_TYPE_ADD_REQUEST, AddProofTypeSaga);
    yield takeLatest(ActionTypes.PROOF_TYPE_UPDATE_REQUEST, UpdateProofTypeSaga);
    yield takeLatest(ActionTypes.PROOF_TYPE_DELETE_REQUEST, DeleteProofTypeSaga);
    yield takeLatest(ActionTypes.NOTIFICATION_GET_REQUEST, GetNotificationSaga);
    yield takeLatest(ActionTypes.ALL_NOTIFICATION_GET_REQUEST, GetAllNotificationSaga);
    yield takeLatest(ActionTypes.NOTIFICATION_ADD_REQUEST, AddNotificationSaga);
    yield takeLatest(ActionTypes.NOTIFICATION_UPDATE_REQUEST, UpdateNotificationSaga);
    yield takeLatest(ActionTypes.DOCUMENTATIONS_GET_REQUEST, GetDocumentationsSaga);
    yield takeLatest(ActionTypes.DOCUMENTATIONS_ADD_REQUEST, AddDocumentationsSaga);
    yield takeLatest(ActionTypes.DOCUMENTATIONS_UPDATE_REQUEST, UpdateDocumentationsSaga);
    yield takeLatest(ActionTypes.DOCUMENTATIONS_DELETE_REQUEST, DeleteDocumentationsSaga);
    yield takeLatest(ActionTypes.GET_USERS_REQUEST, GetUsersSaga);
    yield takeLatest(ActionTypes.GET_WORKSPACEDOJ_REQUEST, GetWorkSpaceDojSaga);
    yield takeLatest(ActionTypes.CONFIGURE_STATUS_GET_REQUEST, GetConfigureStatusSaga);
    yield takeLatest(ActionTypes.CONFIGURE_STATUS_UPDATE_REQUEST, UpdateConfigureStatusSaga);
    yield takeLatest(ActionTypes.COUNTRY_GET_REQUEST, GetCountrySaga);
    yield takeLatest(ActionTypes.WEEK_DAYS_GET_REQUEST, GetWeekDaysSaga);
    yield takeLatest(ActionTypes.SUBSCRIPTION_GET_REQUEST, GetSubscriptionSaga);
    yield takeLatest(ActionTypes.SUBSCRIPTION_UPDATE_REQUEST, UpdateSubscriptionSaga);
    yield takeLatest(ActionTypes.LETTER_HEAD_GET_REQUEST, GetLetterHeadSaga);
    yield takeLatest(ActionTypes.LETTER_HEAD_UPDATE_REQUEST, UpdateLetterHeadSaga);
    yield takeLatest(ActionTypes.REPORT_SCHEDULE_GET_REQUEST, GetReportScheduleSaga);
    yield takeLatest(ActionTypes.REPORT_SCHEDULE_UPDATE_REQUEST, UpdateReportScheduleSaga);
    yield takeLatest(ActionTypes.REPORT_SCHEDULE_DELETE_REQUEST, DeleteReportScheduleSaga);
    yield takeLatest(ActionTypes.COMPANY_LOGO_GET_REQUEST, GetCompanyLogoSaga);
    yield takeLatest(ActionTypes.COMPANY_LOGO_UPDATE_REQUEST, UpdateCompanyLogoSaga);
    yield takeLatest(ActionTypes.FACEAPI_LOAD_REQUEST, LoadFaceApiModelsSaga);
    yield takeLatest(ActionTypes.GET_AI_CONFIG_REQUEST, GetAITokenConfig);
    yield takeLatest(ActionTypes.ADD_AI_CONFIG_REQUEST, AddAITokenConfig);
    yield takeLatest(ActionTypes.UPDATE_AI_CONFIG_REQUEST, UpdateAITokenConfig);
    yield takeLatest(ActionTypes.DELETE_AI_CONFIG_REQUEST, DeleteAITokenConfig);
    yield takeLatest(ActionTypes.TEST_MODEL_REQUEST, TestModel);
    yield takeLatest(ActionTypes.COMPANY_CONFIG_GET_REQUEST, GetCompanyConfigSaga);
    yield takeLatest(ActionTypes.COMPANY_CONFIG_UPDATE_REQUEST, UpdateCompanyConfigSaga);
    yield takeLatest(ActionTypes.CONTRACTOR_GET_REQUEST, GetContractorSaga);
    yield takeLatest(ActionTypes.CONTRACTOR_ADD_REQUEST, AddContractorSaga);
    yield takeLatest(ActionTypes.CONTRACTOR_UPDATE_REQUEST, UpdateContractorSaga);
    yield takeLatest(ActionTypes.CONTRACTOR_DELETE_REQUEST, DeleteContractorSaga);
    yield takeLatest(ActionTypes.WHATSAPP_CONFIG_GET_REQUEST, GetWhatsappConfigSaga);
    yield takeLatest(ActionTypes.WHATSAPP_CONFIG_UPSERT_REQUEST, UpsertWhatsappConfigSaga);
    yield takeLatest(ActionTypes.WHATSAPP_CONFIG_TEST_REQUEST, TestWhatsappConfigSaga);
}
